import React, { useState } from "react";
import { UserGroupDTO } from "../types/userGroupDTO";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { fi } from 'date-fns/locale';
import { registerLocale } from "react-datepicker";

registerLocale('fi', fi);

type Args = {
    headerText: string;
    userGroup: UserGroupDTO;
    submitted: (userGroup: UserGroupDTO) => void;
    deleted?: (userGroup: UserGroupDTO) => void;
};

const UserGroupForm = ({ headerText, userGroup, submitted, deleted }: Args) => {
    const { t, i18n } = useTranslation();
    const nav = useNavigate();
    const [userGroupState, setuserGroupState] = useState(userGroup);

    const onSubmit: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        e.preventDefault();
        submitted(userGroupState);
    };

    const onCancel: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        e.preventDefault();
        nav(-1);
    };

    const onDelete: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        e.preventDefault();
        deleted?.(userGroupState);
    };

   

    return (
        <div className="ml-3">
            <h5 className="subtitle text-left mb-2">{headerText}</h5>
            <form>
               
                <div className="form-group">
                    <label htmlFor="name">{t('common.name')}</label>
                    <input
                        type="text"
                        maxLength={200}
                        className="form-control"
                        value={userGroupState.name}
                        onChange={(e) =>
                            setuserGroupState({ ...userGroupState, name: e.target.value })
                        }
                    />
                </div>
               
                <div className="form-group mt-2">
                    <label htmlFor="validFrom">{t('common.validFrom')}</label>
                    <div>
                        <DatePicker
                            className="form-control"
                            dateFormat={i18n.language === 'en' ? 'yyyy-MM-dd hh:mm' : 'dd.MM.yyyy HH:mm'}
                            locale={i18n.language === 'fi' ? 'fi' : 'en'}
                            selected={userGroupState.validFrom}
                            onChange={(date: Date | null) => date && setuserGroupState({ ...userGroupState, validFrom: date })}
                            showTimeSelect
                        />
                    </div>
                </div>
                <div className="form-group mt-2">
                    <label htmlFor="validTo">{t('common.validTo')}</label>
                    <div>
                        <DatePicker
                            className="form-control"
                            dateFormat={i18n.language === 'en' ? 'yyyy-MM-dd hh:mm' : 'dd.MM.yyyy HH:mm'}
                            locale={i18n.language === 'fi' ? 'fi' : 'en'}
                            selected={userGroupState.validTo}
                            onChange={(date: Date | null) => date && setuserGroupState({ ...userGroupState, validTo: date })}
                            showTimeSelect
                        />
                    </div>
                </div>
                <button
                    className="btn btn-primary mt-3 me-2"
                    disabled={!userGroupState.name}
                    onClick={onSubmit}>
                    {t('buttons.save')}
                </button>
                {deleted && (
                    <button
                        className="btn btn-danger mt-3 me-2"
                        onClick={onDelete}>
                        {t('buttons.delete')}
                    </button>
                )}
                <button
                    className="btn btn-danger mt-3"
                    onClick={onCancel}>
                    {t('buttons.cancel')}
                </button>
            </form>
        </div>
    );
};

export default UserGroupForm;
